/*
  Need to disable this rule because I'm using styles[type], so based on the Alert type (success, warning, error),
  the class is configured dynamically.
 */
/* eslint-disable css-modules/no-unused-class */
import classnames from 'classnames';
import * as React from 'react';
import BanIcon from '../../icons/BanIcon';
import CheckIcon from '../../icons/CheckIcon';
import WarningIcon from '../../icons/WarningIcon';
import { AlertProps } from './models';
import styles from './styles/alert.scss';

const Icon = ({ type }: Pick<AlertProps, 'type'>) => {
  switch (type) {
    case 'success':
      return <CheckIcon />;
    case 'warning':
      return <WarningIcon />;
    case 'error':
      return <BanIcon />;
    default:
      return null;
  }
};

// eslint-disable-next-line complexity
const Alert = ({
  className,
  title,
  type,
  text,
  buttonText,
  onClick,
  onSecondaryButtonClick,
  secondaryButtonText,
  showIcon = true,
  fill,
  styled = true,
  style,
}: AlertProps) => (
  <div
    className={classnames(
      styles.root,
      styles[type],
      {
        [styles.styled]: styled,
        [styles.filled]: fill,
      },
      className,
      'Sui-Alert--root'
    )}
    style={style}
  >
    {showIcon ? (
      <div className={classnames(styles.icon, 'Sui-Alert--icon')}>
        <Icon type={type} />
      </div>
    ) : null}
    <div className={classnames(styles.info, 'Sui-Alert--info')}>
      <div className={classnames(styles.title, 'Sui-Alert--title')}>
        {title}
      </div>
      {text ? (
        <div className={classnames(styles.text, 'Sui-Alert--text')}>{text}</div>
      ) : null}
    </div>

    {(onClick && buttonText && !secondaryButtonText) ||
    (type === 'success' && buttonText) ||
    (type === 'warning' && buttonText) ? (
      <div className={classnames(styles.actionContainer, 'Sui-Alert--action')}>
        <button role="button" className={styles.button} onClick={onClick}>
          {buttonText}
        </button>
      </div>
    ) : null}

    {onClick && buttonText && secondaryButtonText && type === 'error' ? (
      <div
        className={classnames(
          styles.actionContainer,
          'Sui-Alert--action-with-secondary'
        )}
      >
        <button
          role="button"
          className={'Sui-Alert--alertbtn-secondary'}
          onClick={onSecondaryButtonClick}
        >
          {secondaryButtonText}
        </button>
        <button
          role="button"
          className={'Sui-Alert--alertbtn-primary'}
          onClick={onClick}
        >
          {buttonText}
        </button>
      </div>
    ) : null}
  </div>
);

export default Alert;
